import { useState } from 'react';
import moment from 'moment';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'hooks/useAppSelector';
import { selectDetails } from 'state/direct-debit/direct-debit-slice';
import { useSalesOrder } from 'components/direct-sales/order-summary/hooks/useSalesOrder';
import {
  selectErrors as selectSalesOrderErrors,
  selectIsLoading
} from 'state/sales-order/sales-order-slice';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { useCurrentProduct } from 'components/direct-sales/quote/hooks/useCurrentProduct';
import { useExitFeeValue } from 'components/direct-sales/quote/hooks/useExitFees';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { selectedAddress } from 'state/selected-address/selected-address-slice';

export const useOrderSummary = () => {
  const [, setTermsValue] = useState(false);

  const address = useAppSelector(selectedAddress, shallowEqual);
  const directDebitDetails = useAppSelector(selectDetails, shallowEqual);
  const { paymentDate } = directDebitDetails;
  const errors = useAppSelector(selectSalesOrderErrors, shallowEqual);
  const isLoading = useAppSelector(selectIsLoading, shallowEqual);
  const { paymentName, isAnyDirectDebit } = usePaymentMethod();
  const salesOrderPayload = useSalesOrder();
  const product = useCurrentProduct();
  const {
    productName,
    monthlyAmount = 0,
    electricityQuote,
    gasQuote,
    annualAmount,
    tariffEndsOn,
    specifics,
    isTOU
  } = product;
  const fuelType = useAppSelector(selectFuelType, shallowEqual);
  const formatedPaymentDay =
    paymentDate && moment.localeData().ordinal(paymentDate);
  const { full: exitFee } = useExitFeeValue(product);

  const fuelTypeLabel = [
    ...(fuelType.gas ? ['Gas'] : []),
    ...(fuelType.electric ? ['Electricity'] : [])
  ].join(' & ');

  const nextMonth = moment().add(1, 'month');
  const firstPaymentDate =
    paymentDate && `${paymentDate}${nextMonth.format('/MM/YY')}`;
  const tariffTermsHTML = specifics?.find(
    (spec) => spec.title === 'Read British Gas Terms & Conditions'
  )?.description;
  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(
    tariffTermsHTML as string,
    'text/html'
  );
  const tariffTermsPDF = htmlDoc.querySelector('a')?.href;

  return {
    setTermsValue,
    salesOrderPayload,
    firstPaymentDate,
    productName,
    fuelTypeLabel,
    monthlyAmount,
    formatedPaymentDay,
    errors,
    isLoading,
    paymentName,
    electricityQuote,
    gasQuote,
    annualAmount,
    exitFee,
    tariffEndsOn,
    tariffTermsPDF,
    isTOU,
    isAnyDirectDebit,
    directDebitDetails,
    supplyAddress: address
  };
};
